import {
  Button, Dialog, DialogActions, DialogContent, DialogTitle,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow, TextField,
} from "@mui/material";
import { MgCookResponse } from "../../interfaces/Cook/MgCookResponse";
import React, { useState } from "react";
import { CreateMgCookDialog } from "../Common/CreateMgCookDialog";
import { CookService } from "../../services/CookServices";
import EventBus from "../../EventBus";
import { EventBusEventsEnum } from "../../enums/EventBusEventsEnum";
import { CustomSnackbarTypes } from "../Common/CustomSnackBar";
import { formatDate } from "../../utils/DateTimeUtils";
import CommonListTable, { CommonListColumn } from "../Common/CommonListTable";

interface PropsInterface {
  data: MgCookResponse[];
  cookId: number;
  callBack: () => void;
}

const cookService = new CookService();

const CookSalaryList = (props: PropsInterface) => {
  const [editMgCook, setEditMgCook] = useState<boolean>(false);
  const [addComment, setAddComment] = useState<boolean>(false);
  const [comment, setComment] = useState<string>('');
  const [editData, setEditData] = useState<MgCookResponse>();

  const handleAddComment = () => {
    if (!editData) return;
    cookService.createMgCookSalaryComment(Number(editData?.id), {
      comment: comment,
    }).then(() => {
      EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
        message: 'Added Successfully',
        type: CustomSnackbarTypes.SUCCESS
      });
      setAddComment(false);
      props.callBack();
    });
  };

  const columns: CommonListColumn<MgCookResponse>[] = [
    { label: 'Id', field: 'id' },
    { label: 'Start Date', render: (row) => row?.startDate ? formatDate(row?.startDate) : '---' },
    { label: 'End Date', render: (row) => row?.endDate ? formatDate(row?.endDate) : '---' },
    { label: 'Salary', render: (row) => row?.salary || '---' },
    { label: 'Conveyance Included', render: (row) => row?.isConveyanceIncluded ? "YES" : "-" },
    { label: 'Daily MgPayout', render: (row) => row?.dailyMgPayout || "-" },
    { label: 'Daily Conveyance', render: (row) => row?.dailyMgConveyance || "-" },
    { label: 'Salary Version', render: (row) => row?.salaryVersion || "-" },
    {
      label: 'Comments',
      minWidth: 400,
      render: (row) => (
        <Table size={'small'}>
          <TableHead>
            <TableRow>
              <TableCell>{'Sl.No'}</TableCell>
              <TableCell>{'Comment'}</TableCell>
              <TableCell>{'Commented By'}</TableCell>
              <TableCell>{'Commented By Type'}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {row?.comments?.map((eachComment, commentIndex: number) => (
              <TableRow key={eachComment?.comment}>
                <TableCell>{commentIndex + 1}</TableCell>
                <TableCell>{eachComment?.comment || '---'}</TableCell>
                <TableCell>{eachComment?.commentedBy || '---'}</TableCell>
                <TableCell>{eachComment?.commentedByType || '---'}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      ),
    },
    {
      label: '',
      stopRowClick: true,
      render: (row) => (
        <>
          <Button
            variant={'outlined'}
            disabled={!row?.endDate}
            onClick={() => { setEditMgCook(true); setEditData(row); }}
          >
            {'Edit'}
          </Button>
          <Button
            sx={{ ml: 2 }}
            variant={'contained'}
            onClick={() => { setAddComment(true); setEditData(row); }}
          >
            {'Add Comment'}
          </Button>
        </>
      ),
    },
  ];

  return (
    <>
      <CommonListTable
        columns={columns}
        data={props.data}
        loading={false}

        emptyText="No Salary Records Found"
      />
      {editMgCook && (
        <CreateMgCookDialog
          callBack={props.callBack}
          cookId={props.cookId}
          isCreate={false}
          open={editMgCook}
          setOpen={setEditMgCook}
          data={editData}
        />
      )}
      {addComment && (
        <Dialog open={addComment} onClose={() => setAddComment(false)}>
          <DialogTitle>Add Comment</DialogTitle>
          <DialogContent>
            <TextField
              label={'Comment'}
              onChange={(event: any) => { setComment(event.target.value); }}
              sx={{ width: 300 }}
              multiline
              rows={3}
              value={comment}
              fullWidth={true}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={() => { setAddComment(false); }} color={'error'}>Cancel</Button>
            <Button onClick={handleAddComment} color={'primary'} variant={'contained'}>Add</Button>
          </DialogActions>
        </Dialog>
      )}
    </>
  );
};

export default CookSalaryList;
